import { Record } from 'immutable'
import NegotiationCard from './NegotiationCard'

const NegotiationMessageRecord = Record({
	created_at: '',
	created_by: '',
	offer_details: [],
	summary: '',
	title: null,
	type: null,
	status: null,
})

class NegotiationMessage extends NegotiationMessageRecord {
	constructor({ data, ...rest }) {
		const _offerDetails = new NegotiationCard({ data: data?.offer_details ?? [], ...rest })
		let _status = null
		if (_offerDetails.items.some((_i) => _i.status?.toLowerCase() === 'accepted')) {
			_status = 'ACCEPTED'
		}
		if (_offerDetails.items.some((_i) => _i.status?.toLowerCase() === 'rejected')) {
			_status = 'REJECTED'
		}
		super({
			...data,
			offer_details: _offerDetails,
			status: _status,
		})

		this.ownMessage = this.created_by === rest.userId
	}

	setOffer(data) {
		let _offer_details = data ?? null
		if (Array.isArray(data)) {
			_offer_details = data.map((_d) => ({
				..._d,
				status: '',
			}))
		}
		return this.merge({ offer_details: _offer_details })
	}

	isOwnMessage() {
		return this.ownMessage
	}
}

export default NegotiationMessage
